import React from 'react';

const DownloadButton = ({ text, icon, url }) => {
    return (
        <a
            className="btn-store text-14 flex items-center justify-center"
            href={url}
            target="_blank"
            rel="noopener noreferrer"
        >
            <div className="flex items-center justify-center w-56">
                <span className="mr-auto">{icon}</span>
                <span className="mr-auto">{text}</span>
            </div>
        </a>
    );
};

export default DownloadButton;
